import home from './home/reducer'
import language from './language/reducer'
import auth from './auth/reducer'
import organization from './organization/reducer'
import app from './app/reducer'
import user from './user/reducer'
import eventReducer from './event/reducer'
import object from './object/reducer'
import qbmedia from './qbmedia/reducer'
import taskReducer from './task/reducer'
import qbrole from './qbrole/reducer'
import qbreport from './report/reducer'
import scrumBoard from './scrumBoard/reducer'
import drawer from './drawer/reducer'
import modal from './modal/reducer'
import NotifyReducer from './Notify/reducer'
import chartReducer from './chart/reducer'
// component reducer
import component_select_media from './component_select_media/reducer'
import component_select_object from './component_select_object/reducer'
import component_select_event from './component_select_event/reducer'
import component_select_report from './component_select_report/reducer'
import QMreducer from './quickMessage/reducer'
export default {
    app,
    home,
    language,
    auth,
    organization,
    user,
    eventReducer,
    object,
    qbmedia,
    taskReducer,
    qbrole,
    qbreport,
    scrumBoard,
    drawer,
    modal,
    component_select_media,
    component_select_object,
    component_select_event,
    component_select_report,
    NotifyReducer,
    chartReducer,
    QMreducer,
}
